import { render, staticRenderFns } from "./PresentationStandalone.vue?vue&type=template&id=1dc2c21c&scoped=true&"
import script from "./PresentationStandalone.vue?vue&type=script&lang=ts&"
export * from "./PresentationStandalone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2c21c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc2c21c')) {
      api.createRecord('1dc2c21c', component.options)
    } else {
      api.reload('1dc2c21c', component.options)
    }
    module.hot.accept("./PresentationStandalone.vue?vue&type=template&id=1dc2c21c&scoped=true&", function () {
      api.rerender('1dc2c21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/presentationOptions/PresentationStandalone.vue"
export default component.exports